<section class="space-ptb p-3">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-title">
                    <h2 class="title">Jobs You May be Interested in</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <jobs-carousel></jobs-carousel>
            </div>
        </div>
    </div>
</section>